import React from 'react';
import styles from './LabelRequiredText.module.scss';

type Props = {
  /**
   * The content to render within `FormLabelRequiredText`.
   *
   * @default Required
   */
  children?: React.ReactNode;

  /**
   * Whether or not this should render with "disabled" styling.
   *
   * @default false
   */
  isDisabled?: boolean;
};

export const LabelRequiredText = ({ children, isDisabled }: Props) => {
  return (
    // `aria-hidden` to prevent it from being read redundantly.
    // The associated `input` field should indicate whether it's
    // required to screenreaders.
    <span
      aria-hidden="true"
      className={styles.requiredText}
      data-state={isDisabled ? 'disabled' : undefined}
      data-zds
    >
      {children}
    </span>
  );
};
